export default function BrandLogo({ size = 32, className = "", showText = false, textClassName = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img
        src="/brand/logo-sm.png"
        alt="Esports Training Simracing Center"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        className="drop-shadow-[0_0_8px_rgba(34,197,94,0.35)]"
      />
      {showText && (
        <span className={`font-display font-black uppercase tracking-tight leading-none ${textClassName}`}>
          <span className="block text-[0.6em] text-emerald-400 tracking-[0.25em]">ESPORTS TRAINING</span>
          <span className="block">SIMRACING <span className="text-emerald-400">CENTER</span></span>
        </span>
      )}
    </span>
  );
}
